import {mapActions} from 'vuex';
import * as PATIENT from '@/store/constants/patient';
import * as APPOINTMENT from '@/store/constants/appointment';

import PrintPatientSection from './../Print/PatientSection';
import PrintPatientTabularSection from './../Print/PatientTabularSection';

export default {
  data() {
    return {
      patient: {},
      appointments: []
    }
  },
  components: {PrintPatientSection, PrintPatientTabularSection},
  computed: {
    /**
     * Personal Information.
     *
     * @returns {*|Array}
     */
    personal_info() {
      const excludeFields = [
        'id',
        'emergency_contact_id',
        'insurance_id',
        'other_info_id',
        'other_info',
        'emergency_contact',
        'insurance',
        'created_at',
        'updated_at'
      ];

      return this.filterInfo(this.patient, excludeFields);
    },

    insurance() {
      const excludeFields = ['id', 'created_at', 'updated_at'];
      return this.filterInfo(this.patient.insurance, excludeFields);
    },

    /**
     * Other Info.
     * @returns {*|Array}
     */
    other_info() {
      const excludeFields = ['id', 'created_at', 'updated_at'];
      return this.filterInfo(this.patient.other_info, excludeFields);
    },

    /**
     * Emergency Contact
     *
     * @returns {*|Array}
     */
    emergency_contact() {
      const excludeFields = ['id', 'created_at', 'updated_at'];
      return this.filterInfo(this.patient.emergency_contact, excludeFields);
    },

    /**
     * Consolidated information.
     * @returns {*[]}
     */
    allData() {
      return [
        {title: 'Personal Information', data: this.personal_info},
        {title: 'Other Information', data: this.other_info},
        {title: 'Emergency Contact', data: this.emergency_contact},
        {title: 'Insurance', data: this.insurance}
      ];
    },

    filtered_appointments() {
      return {
        fields: ['primary_complaints', 'illness_history', 'diagnosis', 'appointment_date', 'notes'],
        items: this.appointments,
        title: 'Appointments',
        note: 'Only shows latest 50 appointments'
      };
    }
  },
  methods: {
    ...mapActions({
      getPatient: PATIENT.ACTION_GET_PATIENT,
      getAppointments: APPOINTMENT.ACTION_LIST_APPOINTMENTS
    }),

    /**
     * Exclude fields from data.
     *
     * @param data
     * @param excludedFields
     * @returns {Array}
     */
    filterInfo(data, excludedFields) {
      let result = [];

      for (let p in data) {
        if (data.hasOwnProperty(p)) {
          if (excludedFields.indexOf(p) === -1) {
            result.push({key: p, value: data[p]});
          }
        }
      }

      return result;
    }
  },

  created() {
    this.getPatient(this.$route.params['id']).then(res => {
      this.patient = res.data;

      // Get Appointments.
      this.getAppointments({
        filter: [`patient_id,=,${this.patient.id}`]
      }).then(res => {
        this.appointments = res.data.data;
      });
    });
  }
}


// WEBPACK FOOTER //
// ./src/views/Patient/js/patient-preview.js